<template>
	<section class="marketing-section bg-color-white">
		<div class="container">
			<h2 class="heading-1 mb-300-md mb-100-smo text-align-center-md">Assets</h2>
			<BasePlaceHolder
				:placehold="loading"
				:section-count="5"
				:class="{ 'pt-300 container position-relative': loading }"
			>
				<FundDetailsAssetsOverview
					:asset-elements="assetElements"
					:strategy-allocations="strategyAllocations"
					:asset-type-allocations="assetTypeAllocations"
					:center-asset-allocations="true"
				/>
				<div v-if="showLiterature" class="mt-300-md mt-200-smo">
					<h3 class="heading-5">Literature</h3>
					<LiteratureSection
						:literature-list="literatureItems"
						:disclaimer="literatureDisclaimer"
						disclaimer-classes="body-medium col-8-md text-color-content-secondary mt-50 mb-100-md mb-200-smo"
					/>
				</div>
			</BasePlaceHolder>
		</div>
	</section>
</template>

<script setup lang="ts">
import { computed, ref, Ref } from 'vue';
import { FundAssetAllocation, FundLiterature } from 'types/funds';
import { Asset } from 'types/assets';
import FundDetailsAssetsOverview from '@components/offering-details/fund-details/fund-details-assets-overview.vue';
import { getAssets } from '@api/sanity/proxy/assets';
import { getFund } from '@sanity/proxy/funds';
import LiteratureSection from '@components/offering-details/literature-section.vue';
import { ocfReitId } from '@constants/reit';
import { SanityRichTextBlock } from 'types/sanity';

const loading = ref(true);

const literatureItems = ref<Array<FundLiterature>>([]);
const literatureDisclaimer = ref<Array<SanityRichTextBlock>>([]);
const assetElements: Ref<Array<Asset>> = ref([]);
const assetTypeAllocations: Ref<Array<FundAssetAllocation>> = ref([]);
const strategyAllocations: Ref<Array<FundAssetAllocation>> = ref([]);

const showLiterature = computed((): boolean => {
	return literatureItems.value?.length > 0;
});

async function setup(): Promise<void> {
	try {
		const [fundDetails, assetsResponse] = await Promise.all([
			getFund(ocfReitId),
			getAssets({ fundId: [ocfReitId], status: 'ACTIVE' })
		]);

		assetElements.value = assetsResponse.results;
		assetTypeAllocations.value = fundDetails?.assetTypeAllocations ?? [];
		strategyAllocations.value = fundDetails?.strategyAllocations ?? [];
		literatureItems.value = fundDetails?.literature ?? [];
		literatureDisclaimer.value = fundDetails?.literatureDisclaimer ?? [];

		loading.value = false;
	} catch (e) {}
}

setup();
</script>
